import styled from 'styled-components';

const DetailAddonAnimatableText = styled.span<{ hide?: boolean }>`
  opacity: ${(props) => (props.hide ? '0' : '1')};
`;

export default DetailAddonAnimatableText;
